import React from "react";
import { Navigate, Route, Routes, useResolvedPath } from "react-router";
import ServiceWorldCasePage from "../../containers/Pages/ServiceWorld/ServiceWorldCasePage";
import CalendlyPage from "../../containers/Pages/ServiceWorld/CalendlyPage";
import ApplicationFormPage from "../../containers/Pages/ApplicationForm/ApplicationFormPage";
import InquiryToCustomerPage from "../../containers/Pages/ServiceWorld/InquiryToCustomerPage";
import InquiryToCustomerAnsweredPage from "../../containers/Pages/ServiceWorld/InquiryToCustomerAnsweredPage";
import useProductParams from "../../hooks/useProductParams";
import { getProductNameBy } from "../../services/productService";
import Error404Page from "@/src/containers/Pages/Generic/Error404/Error404Page";

export default function ServiceworldCase() {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);

  return (
    <Routes>
      <Route path={"antrag/*"} element={<ApplicationFormPage />} />
      <Route path={"calendly/:responsibleParty/:appointmentType/*"} element={<CalendlyPage />} />
      <Route
        path={"dokumente-hochladen"}
        element={<Navigate to={`/servicewelt/nachrichten/neu?product=${productClassName}&productId=${productId}`} replace={true} />}
      />
      <Route path={"anfrage"} element={<Navigate to={useResolvedPath(".")} />} />
      <Route path={"anfrage/beantwortet"} element={<InquiryToCustomerAnsweredPage />} />
      <Route path={"anfrage/:inquiryId"} element={<InquiryToCustomerPage />} />
      <Route path={""} element={<ServiceWorldCasePage />} />
      <Route path={"*"} element={<Error404Page />} />
    </Routes>
  );
}
